import React, { useEffect, useState } from 'react';

import { Typography, notification, Button, Modal, Divider } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import config from '../../../../../../../config/config.json';

import Core from '../../../../../../../common/Core';

const langContext = 'reserved-area.marketplace';

const { Text, Title } = Typography;

export default ({ wasteTypeUID, uid, radius, onClose }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    useEffect(() => {
        if (uid) {
            setLoading(true);
            _service({
                method: 'GET',
                url: '/marketplace/waste/produce/list',
                data: {
                    uid: uid,
                    waste_type_uid: wasteTypeUID,
                    radius: radius
                },
                success: (response) => {
                    setData(response.json);
                    setLoading(false);
                },
                fail: (e) => {
                    setLoading(false);
                    notification['error']({
                        message: 'Não foi possivel carregar os dados.',
                        description: e.response.json.error,
                    });
                }
            });
        }
    }, []);

    const intl = useIntl();

    const onCancel = () => {
        setIsModalVisible(false);
        if (onClose) {
            onClose();
        }
    };

    return (
        <div>
            {data.map((item) => (
                <>
                    <Modal
                        title={intl.formatMessage({ id: langContext + '.waste.to-consume.title' })}
                        visible={true}
                        onCancel={onCancel}
                        footer={[
                            <Button type='primary' onClick={onClose}>
                                <FormattedMessage id={`${langContext}.button.close`} />
                            </Button>]}
                    >
                        <Title level={4}><FormattedMessage id={langContext + `.fields.details`} /></Title>
                        <p>{intl.formatMessage({ id: langContext + '.fields.distance' })}: <Text strong>{Core.numeral(item.distance)} Kms </Text></p>
                        <p>{intl.formatMessage({ id: langContext + '.fields.estimated-date' })}: <Text strong>{item.waste_produce.estimated_date}</Text></p>
                        <Divider />
                        <Title level={4}><FormattedMessage id={`reserved-area.construction.title`} /></Title>
                        <p>{intl.formatMessage({ id: 'reserved-area.construction.title' })}: <Text strong>{item.name}</Text></p>
                        <p>{intl.formatMessage({ id: langContext + '.fields.address' })}</p>
                        <p><Text strong>{item.address}</Text></p>
                        <p><Text strong>{item.postal_code} {item.locality}, {item.district}</Text></p>
                        <Divider />
                        <Title level={4}><FormattedMessage id={`${langContext}.fields.waste`} /></Title>
                        <p>{intl.formatMessage({ id: langContext + '.fields.description' })}: <Text strong>{item.waste_produce.waste_type.description[intl.locale.split('-')[0]]}</Text></p>
                        <p>{intl.formatMessage({ id: langContext + '.fields.amount' })}: <Text strong>{item.waste_produce.amount} {item.waste_produce.measurement_unit.description[intl.locale.split('-')[0]]}</Text></p>
                        <p>{
                            (item.waste_produce.photo) ?
                                <img src={config.api.services + 'construction/waste/produce/photo?uid=' + item.waste_produce.uid} />
                                : null
                        }</p>
                    </Modal>
                </>
            ))}
        </div>
    )
}